import moment from 'moment'
import React from 'react'
import { MdOutlineErrorOutline } from 'react-icons/md'
import { VscCloudDownload } from 'react-icons/vsc'

const AuditHistory = ({ data, isLoadingID }) => {
	return (
		<div className='Auditsubcontainer'>
			<div className='AuditNavigationcontainer'>
				{isLoadingID ? (
					<tr>
						<td className="table-msg" colSpan={12}>
							<VscCloudDownload size={75} />
							<p>Fetching request...</p>
						</td>
					</tr>
				) : data?.ApplicationStatusLog?.length === undefined ? (
					<tr>
						<td className="table-msg" colSpan={12}>
							<MdOutlineErrorOutline size={75} />
							<p>No Record found!</p>
						</td>
					</tr>
				) : (

					data?.ApplicationStatusLog?.map((info: any, i: any) => (
						<div className='AuditInfoContainer' key={i}>
							<div className='subauditInformation'>
								<div className='subauditinfotitle'>DATE AND TIME</div>
								<div className='jobtext'>
									<p>{moment(info?.createdAt).format("YYYY-MM-DD HH:mm:ss")}</p>
								</div>
							</div>
							<div className='subauditInformation'>
								<div className='subauditinfotitle'>PROCCESD BY</div>
								<div className='jobtext'>
									<p>{info?.Recruiter?.firstName} {info?.Recruiter?.LastName}</p>
									<p>{!info?.Recruiter?.role ? "n/a" : info?.Recruiter?.role}</p>
								</div>
							</div>
							<div className='subauditInformation'>
								<div className='subauditinfotitle'>DETAILS</div>
								<div className='jobtext'>
									<p>Candidate Added</p>
									<p style={{ color: "orangered" }}>{info?.applicationStatus}</p>
								</div>
							</div>
						</div>
					)))}
			</div>
		</div>
	)
}

export default AuditHistory